/**
 * @deprecated use Device.isClient instead
 */
export const windowIsDefined = typeof window !== 'undefined';
